export enum UserType {
  USER = "User",
  BRAND = "Brand",
  UNKNOWN = "Unknown",
}